import IApplicationState from 'app/types/state';
import {
  IOrganisationSectionsSelector,
  IOrganisationSectionsState,
} from 'app/ducks/organisationSections/types';
import { IGroupsState } from 'app/ducks/groups/types';

import _ from 'lodash';

function mapSelect(
  state: IApplicationState,
  n,
): { value: string; label: string } {
  const sa = state.organisationSections.organisationSectionsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getOrganisationSectionsFilteredByCompetitionInSelectFormat(
  state: IApplicationState,
  competitionId,
): any {
  const {
    organisationSectionsById,
  }: IOrganisationSectionsState = state.organisationSections;
  const organisationSections = _.filter(organisationSectionsById, {
    competitions: [{ id: competitionId }],
    contextList: ['section'],
  });
  const sortedOrganisationSections = _.sortBy(
    organisationSections,
    (o) => o.name,
  );
  const mappedSections = _.map(sortedOrganisationSections, (n) => mapSelect(state, n.id));
  return mappedSections;
}

export function getOrganisationSectionsFilteredByIdInSelectFormat(
  state: IApplicationState,
  ids,
): any {
  const {
    organisationSectionsById,
  }: IOrganisationSectionsState = state.organisationSections;
  const organisationSections = _.filter(organisationSectionsById, (obj) => _.includes(ids, obj.id) && _.includes(obj.contextList, 'section'));
  const sortedOrganisationSections = _.sortBy(
    organisationSections,
    (o) => o.name,
  );
  const mappedSections = _.map(sortedOrganisationSections, (n) => mapSelect(state, n.id));
  return mappedSections;
}

export function getOrganisationSectionsFilteredByOrganisationInSelectFormat(
  state: IApplicationState,
  organisationId,
): any {
  const {
    organisationSectionsById,
  }: IOrganisationSectionsState = state.organisationSections;
  const organisationSections = _.filter(organisationSectionsById, {
    organisations: [{ id: organisationId }],
    contextList: ['section'],
  });
  const sortedOrganisationSections = _.sortBy(
    organisationSections,
    (o) => o.name,
  );
  const mappedSections = _.map(sortedOrganisationSections, (n) => mapSelect(state, n.id));
  return mappedSections;
}

export function getOrganisationSectionsByIdInSelectFormat(
  state: IApplicationState,
): any {
  const { organisationSectionIds } = state.organisationSections;
  return _.map(organisationSectionIds, (n) => mapSelect(state, n));
}

export function getOrganisationSectionsByTagAndIdInSelectFormat(
  state: IApplicationState,
): any {
  const {
    organisationSectionsById,
  }: IOrganisationSectionsState = state.organisationSections;
  const organisationSections = _.filter(organisationSectionsById, {
    contextList: ['section'],
  });
  const sortedOrganisationSections = _.sortBy(
    organisationSections,
    (o) => o.name,
  );

  return _.map(sortedOrganisationSections, (n) => mapSelect(state, n.id));
}

export function getOrganisationSectionFilteredByGroupInSelectFormat(
  state: IApplicationState,
  groupId,
  sections,
): any {
  const { groupsById }: IGroupsState = state.groups;
  const group = groupsById[groupId];
  let section;
  if (!_.isEmpty(groupId) && !_.isEmpty(group) && !_.isEmpty(sections)) {
    section = _.find(sections, (sectionOption) => {
      let found = false;
      if (group.sectionName === sectionOption.id) {
        found = true;
      }
      return found;
    });
    if (!_.isEmpty(section)) {
      section = {
        id: section.id,
        name: section.name,
      };
    }
  }
  return section;
}

export function getOrganisationSections(
  state: IApplicationState,
): IOrganisationSectionsSelector {
  return {
    ...state.organisationSections,
    organisationSectionsByIdInSelectFormat: getOrganisationSectionsByIdInSelectFormat(
      state,
    ),
    organisationSectionsByTagAndIdInSelectFormat: getOrganisationSectionsByTagAndIdInSelectFormat(
      state,
    ),
    organisationSectionsFilteredByIdInSelectFormat: (ids): any => getOrganisationSectionsFilteredByIdInSelectFormat(state, ids),
    organisationSectionsFilteredByOrganisationInSelectFormat: (
      organisationId,
    ): any => getOrganisationSectionsFilteredByOrganisationInSelectFormat(
      state,
      organisationId,
    ),
    organisationSectionsFilteredByCompetitionInSelectFormat: (
      competitionId,
    ): any => getOrganisationSectionsFilteredByCompetitionInSelectFormat(
      state,
      competitionId,
    ),
    organisationSectionFilteredByGroupInSelectFormat: (
      groupId,
      sections,
    ): any => getOrganisationSectionFilteredByGroupInSelectFormat(
      state,
      groupId,
      sections,
    ),
  };
}

export function getOrganisationSectionById(state: IApplicationState, id): any {
  if (
    state.organisationSections.organisationSectionsById !== undefined
    && id != null
  ) {
    return state.organisationSections.organisationSectionsById[id];
  }
  return {};
}
